import DOMPurify from 'dompurify';
/* eslint-disable no-bitwise */

const stringUtils = {
    getUID() {
        // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript
        return `IA${Date.now()}${'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
            const randomNumber = Math.random() * 16 | 0;
            const v = (c === 'x')
                ? randomNumber
                : (randomNumber & (0x3 | 0x8));
            return v.toString(16);
        })}`;
    },

    unescapeXML(xmlString) {
        if (typeof xmlString !== 'string') {
            return undefined;
        }
        return xmlString.replace(/&apos;/g, "'")
            .replace(/&quot;/g, '"')
            .replace(/&gt;/g, '>')
            .replace(/&lt;/g, '<')
            .replace(/&amp;/g, '&');
    },

    normalizeDecimalStart(strNr) {
        let stringNumber = strNr;

        if (stringNumber.startsWith('.') || stringNumber.startsWith(',')) {
            stringNumber = `0${stringNumber}`;
            /* allowing .x values and transforming them into 0.x */
        }

        return stringNumber;
    },

    isStringNumber(strNr) {
        let stringNumber = strNr;
        /* numbers with comma are not considered numeric */
        stringNumber = stringNumber.replace(/,/g, '.');

        /* eslint-disable eqeqeq */
        return !(!stringNumber.trim())
            && !stringNumber.startsWith('.')
            && !stringNumber.endsWith('.')
            && ((stringNumber - 0) == stringNumber);
        /* eslint-enable eqeqeq */
    },

    countWords(contentString) {
        let words = 0;
        let wordMatch;

        if (contentString.length > 0) {
            wordMatch = contentString.match(/\S+/g);
            if (wordMatch !== null) {
                words = wordMatch.length;
            }
        }

        return words;
    },

    countChars(contentString) {
        return contentString ? contentString.replace(/\s/g, '').length : 0;
    },

    whitespaceSubstring(contentString, limit) {
        if (isNaN(limit) || limit <= 0) {
            return contentString;
        }

        let position = 0;
        let count = 0;
        while (count < limit && position < contentString.length) {
            count += /\s/.test(contentString.charAt(position)) ? 0 : 1;
            position++;
        }

        return contentString.substring(0, position);
    },

    numbersOnly(element, objEvent) {
        let iKeyCode = null;
        if (objEvent.keyCode) iKeyCode = objEvent.keyCode;
        if (objEvent.which) iKeyCode = objEvent.which;

        let foundDot = 0;
        if (element.value.indexOf('.') > -1 || element.value.indexOf(',') > -1) {
            foundDot = 1;
        }
        let selected = '';
        if (document.selection && document.selection.createRange) {
            selected = document.selection.createRange();
            selected = selected.text;
        }

        if (selected.indexOf('.') > -1 || selected.indexOf(',') > -1) {
            foundDot = 0;
        }

        if ((iKeyCode >= 48 && iKeyCode <= 57) || (iKeyCode === 44 && foundDot === 0)) {
            return true;
        }
        if (iKeyCode === 46 && foundDot === 0) {
            return true;
        }
        if (iKeyCode === 45 && (element.value.lastIndexOf('-') < 0 && selected.length === 0)) {
            return true;
        }
        if (iKeyCode === 45 && (element.value.lastIndexOf('-') > -1 && selected.length === 0)) {
            return false;
        }
        if (iKeyCode === 45 && (element.value.lastIndexOf('-') === -1 && selected.length > 0)) {
            document.selection.createRange().text = '';
            self.focus();
            element.focus();
            document.selection.createRange().text = '-';
            return false;
        }
        if (iKeyCode === 45 && element.value.lastIndexOf('-') > -1 && selected.length > 0 && selected.lastIndexOf('-') === -1) {
            return false;
        }
        if (iKeyCode === 45 && element.value.lastIndexOf('-') > -1 && selected.length > 0 && selected.lastIndexOf('-') > -1) {
            return true;
        }
        if (iKeyCode === 37 || iKeyCode === 39) {
            if (typeof (objEvent.which) === 'undefined' || objEvent.which === 37 || objEvent.which === 39) {
                return false;
            }
            return true;
        }
        if (iKeyCode === 8 || iKeyCode === 9) {
            return true;
        }
        return false;
    },

    removeNonPrintableChars(string) {
        if (typeof string !== 'string') {
            return string;
        }

        // See TEII-4868
        // This regexp does not cover all non-printable chars, but only onces that are mentioned in scope of the jira issue
        // If more related issues come, then the regexp need to be extended with new chars
        // eslint-disable-next-line no-control-regex
        const nonPrintableChars = /[\x00-\x09\x0b-\x1F]/g;

        return string.replace(nonPrintableChars, '');
    },

    /**
     * Removes HTML tags from a string.
     * @param {string} htmlString - The string possibly containing HTML.
     * @returns {string} The string with HTML tags removed.
     */
    stripHtml(htmlString) {
        if (typeof htmlString !== 'string') {
            return '';
        }
        // Use a regex to remove all content between < and > (which covers most HTML tags)
        return DOMPurify.sanitize(htmlString, {
            ALLOWED_TAGS: [],
            RETURN_DOM: false,
            RETURN_DOM_FRAGMENT: false,
        });
    },
};

export default stringUtils;
